module.exports = __webpack_public_path__ + "static/media/birds.a29aeb28.png";